import { App } from 'vue'
import KInput from './src/input.vue'

KInput.install = (app: App): void => {
  app.component(KInput.name, KInput)
}

export default KInput
